<!--设备管理-->
<template>
  <div class="equip-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="80px">
        <el-row :gutter="32" type="flex" justify="space-between">
          <el-col :span="4">
            <el-form-item prop="searchValue" label-width="54px" label="关键字">
              <el-input
                v-model.trim="queryForm.searchValue"
                placeholder="请输入协议名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="添加时间">
              <el-date-picker
                v-model="dateTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="dateTimeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="status" label="协议状态">
              <el-select v-model="queryForm.status" placeholder="请选择" style="width: 100%">
                <el-option label="启用" value="0"></el-option>
                <el-option label="停用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" style="margin-right: 6px" @click="handleSearch"
              >搜索</el-button
            >
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="4" style="text-align: right">
            <el-button type="primary" @click="handleAdd">点击新增</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <!-- :span-method="typeMerge" -->
      <el-table :data="dealList" v-loading="tableLoading" :span-method="typeMerge" border>
        <el-table-column width="60" label="序号" align="center" :resizable="false"
          ><template slot-scope="{ $index }">
            {{ tempIndex[$index].index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="150"
          prop="protocolName"
          label="协议名称"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          min-width="150"
          prop="protocolVersion"
          label="协议版本"
          align="center"
          show-overflow-tooltip
          :resizable="false"
        ></el-table-column>
        <el-table-column
          min-width="150"
          prop="createTime"
          label="添加时间"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          min-width="350"
          prop="serverIp"
          label="服务器IP"
          align="center"
          show-overflow-tooltip
          :resizable="false"
        >
          <template slot-scope="{ row }">
            {{ row.serverIp || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="150"
          prop="versionStatus"
          label="版本状态"
          align="center"
          :resizable="false"
        >
          <template slot-scope="{ row }">
            <el-switch
              :disabled="row.status == 1"
              :value="row.versionStatus == 1 ? false : true"
              active-color="#67c33a"
              inactive-color="#f56c6c"
              @change="handleVersionStatusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          min-width="150"
          prop="status"
          label="协议状态"
          align="center"
          :resizable="false"
        >
          <template slot-scope="{ row }">
            <el-switch
              :value="row.status == 1 ? false : true"
              active-color="#67c33a"
              inactive-color="#f56c6c"
              @change="handleStatusChange(row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              style="margin-right: 8px"
              content="查看"
              placement="top"
            >
              <i class="iconfont iconcaozuo-8chakanxiangqing_1" @click="handleDetail(row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="分配服务器" placement="top">
              <i
                class="iconfont iconcaozuo-4fenpeiguanliyuanjiaosequanxian_1"
                @click="handleServe(row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[5, 10, 15, 20]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <AddOrEdit ref="addOrEdit" @back="addBack" />
    <ValidatPass ref="validatPass" @back="validateBack" />
    <ServerDistribution ref="serverDistribution" @back="addBack" />
  </div>
</template>

<script>
import dealApi from 'api/home/deal-mangement';
import validatePassApi from 'api/home/validatePass';
import ValidatPass from '@/components/PermissionPassword/ValidatPass';
import AddOrEdit from './AddOrEdit';
import ServerDistribution from './ServerDistribution';
export default {
  components: {
    AddOrEdit,
    ValidatPass,
    ServerDistribution
  },
  data() {
    return {
      total: 0,
      dateTime: '',
      queryForm: {
        pageNo: 1,
        pageSize: 5,
        searchValue: '',
        status: '',
        searchBeginTime: '',
        searchEndTime: ''
      },
      tableLoading: false,
      tempIndex: {},
      dealList: [],
      realList: []
    };
  },
  created() {
    this.getDealList();
  },
  methods: {
    // 日期选择
    dateTimeChange(val) {
      if (val) {
        this.queryForm.searchBeginTime = val[0];
        this.queryForm.searchEndTime = val[1];
      } else {
        this.queryForm.searchBeginTime = '';
        this.queryForm.searchEndTime = '';
      }
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getDealList();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.dateTime = '';
      this.queryForm.searchBeginTime = '';
      this.queryForm.searchEndTime = '';
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 5;
      this.getDealList();
    },
    // 获取设备列表数据
    getDealList() {
      this.tableLoading = true;
      dealApi
        .getDeaList(this.queryForm)
        .then(res => {
          let { data, code } = res.data;
          if (code === 200) {
            this.total = data.totalRows;
            this.dealList = this.tableReset(data.rows);
          }
          this.tableLoading = false;
          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getDealList();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getDealList();
    },
    //密钥验证返回
    validateBack(flag) {
      if (!flag) {
        return;
      }
      this.getDealList();
    },
    //新增OR编辑返回
    addBack(flag, addOrEdit) {
      if (!flag) {
        return;
      }
      if (addOrEdit) {
        this.queryForm.pageNo = 1;
      }
      this.getDealList();
    },
    // 点击新增
    handleAdd() {
      this.$refs.addOrEdit.init();
    },
    // 查看详情
    handleDetail(row) {
      this.$refs.addOrEdit.init(row, true);
    },
    // 点击分配服务器
    handleServe(row) {
      const flag = row.status || row.versionStatus;
      this.$refs.serverDistribution.init({ ...row, isDisabled: flag });
    },
    // 列表开关状态修改
    // 协议
    handleStatusChange(row) {
      const { status, id } = row;
      if (status == 1) {
        validatePassApi.editDealStatus({ status: 0, id }, '').then(res => {
          if (res.data.code === 200) {
            this.getDealList();
          }
        });
      } else {
        this.$refs.validatPass.init({ status: 1, id }, 1, true);
      }
    },
    // 版本
    handleVersionStatusChange(row) {
      const { versionStatus, versionId } = row;
      if (versionStatus == 1) {
        validatePassApi.editVersionStatus({ status: 0, id: versionId }, '').then(res => {
          if (res.data.code === 200) {
            this.getDealList();
          }
        });
      } else {
        this.$refs.validatPass.init({ status: 1, id: versionId }, 2, true);
      }
    },
    // 表格重做
    tableReset(data) {
      let arr = [];
      let tempIndex = {};
      let mainNum = 0;
      let tmepNum = 0;
      let index = 0;
      for (const keys in data) {
        if (data[keys].protocolVersionResultList && data[keys].protocolVersionResultList.length) {
          let sourceArr = data[keys].protocolVersionResultList.map(item => {
            tempIndex[tmepNum] = {
              index,
              mainNum,
              occupyNum: data[keys].protocolVersionResultList.length
            };
            tmepNum++;
            return {
              id: data[keys].id,
              versionId: item.id,
              versionStatus: item.status,
              protocolVersion: item.protocolVersion,
              createTime: item.createTime,
              serverIp: item.serverIp,
              protocolName: data[keys].protocolName,
              status: data[keys].status
            };
          });
          arr.push(...sourceArr);
          mainNum = tmepNum;
          index++;
        }
      }
      this.tempIndex = tempIndex;
      return arr;
    },
    // 单元格合并
    typeMerge({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 1 || columnIndex === 6) {
        if (this.tempIndex[rowIndex].mainNum == rowIndex) {
          return {
            rowspan: this.tempIndex[rowIndex].occupyNum,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      // if (columnIndex === 6) {
      //   if (this.tempIndex[rowIndex].mainNum == rowIndex) {
      //     return {
      //       rowspan: this.tempIndex[rowIndex].occupyNum,
      //       colspan: 1
      //     };
      //   } else {
      //     return {
      //       rowspan: 0,
      //       colspan: 0
      //     };
      //   }
      // }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

// /deep/ .el-table .cell {
//   white-space: pre;
// }
.equip-container {
  padding: 16px;

  .page {
    margin: 16px 0;
    text-align: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
</style>
